import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

const useResonanceTabs = () => {
  const { t } = useTranslation('resonance');

  const isProjectLoading = useSelector((state) => state.resonance.isProjectLoading);
  return useMemo(
    () => [
      {
        label: t('backgroundData'),
        disabled: isProjectLoading,
      },
      {
        label: t('messageResponse'),
        disabled: isProjectLoading,
      },
      {
        label: t('conceptResponse'),
        disabled: isProjectLoading,
      },
      {
        label: t('benchmarks'),
        disabled: isProjectLoading,
      },
    ],
    [isProjectLoading, t],
  );
};

export default useResonanceTabs;
